import React, { Component } from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { Button, Modal, Input } from 'antd';
import './styles.scss';

import StationList from './components/StationList';
import { HardwareContext } from '../../context/HardwareContext';

class DevicePage extends Component {
    static contextType = HardwareContext;

    constructor(props) {
        super(props);

        this.state = {
            stationsHidden: false,
            unassignedHidden: false,
            discoverVisible: false,
            disableRediscover: false,
            visible: false,
            stationName: ''
        };
    }

    onIconClick = (e) => {
        e.stopPropagation();
    };

    onClick = (section) => {
        this.setState((state) => {
            let newState = {};
            newState[section] = !state[section];
            return newState;
        });
    };

    onDrop = (e) => {
        e.preventDefault();
        let deviceId = e.dataTransfer.getData('text/plain');
        this.context.assignDeviceToStation(deviceId, null);
    };

    newStation = (e) => {
        e.preventDefault();

        this.context.createStation(this.state.stationName);

        this.setState({ visible: false, stationName: '' });
    };

    componentDidMount() {
        this.context.getDeviceTypes();
        this.context.fetchDevices();
        this.context.fetchStations();
        this.context.fetchPeripherals();
        this.devicesIntervalId = setInterval(() => {
            this.context.fetchDevices();
        }, 10000);
        this.stationsIntervalId = setInterval(() => {
            this.context.fetchStations();
        }, 10000);
        this.peripheralsIntervalId = setInterval(() => {
            this.context.fetchPeripherals();
        }, 10000);
    }

    componentWillUnmount() {
        clearInterval(this.devicesIntervalId);
        clearInterval(this.stationsIntervalId);
        clearInterval(this.peripheralsIntervalId);
    }

    render() {
        return (
            <div id="device-page" className="devices">
                <div className="device-section-header">
                    <div>
                        <div>
                            <Button
                                type="primary"
                                shape="round"
                                icon={<PlusOutlined />}
                                onClick={() => this.setState({ visible: true })}
                            >
                                New Station
                            </Button>
                            <Modal
                                title="Create Station"
                                open={this.state.visible}
                                onOk={() => this.setState({ visible: false })}
                                onCancel={() => this.setState({ visible: false })}
                                footer={
                                    <div className="footer">
                                        <div className="buttons">
                                            <Button type="primary" onClick={this.newStation}>
                                                Create
                                            </Button>
                                            <Button
                                                onClick={() => {
                                                    this.setState({ visible: false });
                                                }}
                                            >
                                                Cancel
                                            </Button>
                                        </div>
                                    </div>
                                }
                            >
                                <React.Fragment>
                                    <div>Station Name:</div>
                                    {this.state.visible && (
                                        <Input
                                            value={this.state.stationName}
                                            onChange={(e) => this.setState({ stationName: e.target.value })}
                                            onPressEnter={this.newStation}
                                            autoFocus
                                        />
                                    )}
                                </React.Fragment>
                            </Modal>
                        </div>
                    </div>
                </div>
                <StationList className={'device-section' + (this.state.stationsHidden ? ' flex-hide' : '')} />
            </div>
        );
    }
}

export default DevicePage;
